module.exports = __webpack_public_path__ + "static/img/icons8-doughnut_chart.158cdb5f.svg";